import { render, staticRenderFns } from "./CRMExport.vue?vue&type=template&id=50fe418a&scoped=true&"
import script from "./CRMExport.vue?vue&type=script&lang=js&"
export * from "./CRMExport.vue?vue&type=script&lang=js&"
import style0 from "./CRMExport.vue?vue&type=style&index=0&id=50fe418a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe418a",
  null
  
)

export default component.exports